import * as React from 'react';
import FileView from '../../../components/FileView';

/**
 * Renders the attachments carried by a timeline entry.
 *
 * They arrive on the entry itself. The previous GetFiles component issued a
 * /cvf request per row on mount, so a page of fifty rows could fire fifty
 * requests just to draw its attachment strips.
 *
 * FileView is shared with the Files tab and speaks the older PascalCase file
 * shape, so the mapping happens here rather than by changing a component three
 * other screens depend on.
 */

function resolveFileType(file) {
    if (file.file_type === "Image" || file.file_type === "Video") {
        return file.file_type;
    }
    const extension = (file.file_name || "").split(".").pop();
    return extension || file.file_type;
}

export default function CombinedViewFiles({ files, entry, isPrintPreview }) {
    if (!files || files.length === 0) {
        return null;
    }

    const mapped = files.map((file) => ({
        Id: file.id,
        FileName: file.file_name,
        FileType: resolveFileType(file),
        FileSize: file.file_size,
        FileGuid: file.guid,
        Caption: file.caption,
        CanModifyCaption: file.can_modify_caption,
        ThumbFileUrl: file.thumbnail_url,
        OpenFileUrl: file.url,
        // Print preview renders the image inline and suppresses the download
        // link, since the printed page cannot act on one.
        FileUrl: isPrintPreview ? "" : file.url,
        FilePreviewUrl: isPrintPreview ? file.url : file.preview_url
    }));

    return (
        <div className="file_listing">
            <div className="fileAttachment">
                <FileView fileData={{ Files: mapped }} cvData={entry} />
            </div>
        </div>
    );
}
